import level001 from './Level 001 NEW.json';
import level002 from './Level 002 NEW.json';
import level003 from './Level 003 NEW.json';
import level004 from './Level 004 NEW.json';
import level005 from './Level 005 NEW.json';
import level006 from './Level 006 NEW.json';
import level007 from './Level 007 NEW.json';
import level008 from './Level 008 NEW.json';
import level009 from './Level 009 NEW.json';
import level010 from './Level 010 NEW.json';
import level011 from './Level 011 NEW.json';
import level012 from './Level 012 NEW.json';
import level013 from './Level 013 NEW.json';
import level014 from './Level 014 NEW.json';
import level015 from './Level 015 NEW.json';
import level016 from './Level 016 NEW.json';
import level017 from './Level 017 NEW.json';
import level018 from './Level 018 NEW.json';
import level019 from './Level 019 NEW.json';
import level020 from './Level 020 NEW.json';
import level021 from './Level 021 NEW.json';
import level022 from './Level 022 NEW.json';
import level023 from './Level 023 NEW.json';
import level024 from './Level 024 NEW.json';
import level025 from './Level 025 NEW.json';
import level026 from './Level 026 NEW.json';
import level027 from './Level 027 NEW.json';
import level028 from './Level 028 NEW.json';
import level029 from './Level 029 NEW.json';
import level030 from './Level 030 NEW.json';
import type { LevelData } from '../../src/game/level/LevelData';

export const NEW_RAW_LEVELS: Partial<LevelData>[] = [
  level001 as unknown as LevelData,
  level002 as unknown as LevelData,
  level003 as unknown as LevelData,
  level004 as unknown as LevelData,
  level005 as unknown as LevelData,
  level006 as unknown as LevelData,
  level007 as unknown as LevelData,
  level008 as unknown as LevelData,
  level009 as unknown as LevelData,
  level010 as unknown as LevelData,
  level011 as unknown as LevelData,
  level012 as unknown as LevelData,
  level013 as unknown as LevelData,
  level014 as unknown as LevelData,
  level015 as unknown as LevelData,
  level016 as unknown as LevelData,
  level017 as unknown as LevelData,
  level018 as unknown as LevelData,
  level019 as unknown as LevelData,
  level020 as unknown as LevelData,
  level021 as unknown as LevelData,
  level022 as unknown as LevelData,
  level023 as unknown as LevelData,
  level024 as unknown as LevelData,
  level025 as unknown as LevelData,
  level026 as unknown as LevelData,
  level027 as unknown as LevelData,
  level028 as unknown as LevelData,
  level029 as unknown as LevelData,
  level030 as unknown as LevelData,
];